import { Component, ViewChild } from "@angular/core";
import { CKEditorComponent } from "ng2-ckeditor";

import * as $ from "jquery";

import { ConsultasService } from "../../services/consultas.service";
import { SweetAlertModals } from "../Clases/alert";
import { ValidarPermisos } from "../consulta-facturas/ClasesFacturas/Permisos";
import { Router } from '@angular/router';

declare var jQuery: any;
declare var $: any;
@Component({
  selector: "app-edicion",
  templateUrl: "./edicion.component.html",
  styleUrls: ["./edicion.component.css"]
})
export class EdicionComponent {
  formato: any =
    '<p style="text-align: center;"><a href="http://www.repobox.com.mx"><img alt="Repobox" src="../assets/NuevoIndex/img/logos/logo.png" /></a></p> <p style="text-align: center;"><a href="{LinkImpresion}">Haz click aqu&iacute; para imprimir tu comprobante</a>&nbsp;Fecha de Recepci&oacute;n: <strong>{FECHA}</strong>A continuaci&oacute;n el resultado de la validaci&oacute;n de su comprobante fiscal:Folio de Validaci&oacute;n: <strong>{FOLIOVALIDACION}</strong>Folio de Env&iacute;o: <strong>{FOLIOENVIO}</strong>Emisor:<strong>{EMISOR}</strong>RFC:{RFCEMISOR}Receptor:<strong>{RECEPTOR}</strong>RFC:{RFCRECEPTOR}Folio:{FOLIOFAC}Fecha:{FECHAFAC}Serie:{SERIEFAC}UUID:{UUID}Resultado de Validaci&oacute;n:<img src="{IMGSTATUS}" /> {ERRORES}{TablaErrores}</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;"><img alt="Repobox Footer" src="http://www.repobox.com.mx/img/img_new/footer_repobox.png" style="float:left; height:160px; width:1000px" /><!-- SECCION TRES --></p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;"><!-- SECCION TRES PUNTO CINCO--><!--<td style="padding: 0 20px 40px 20px ;font-size: 14px; font-family: Segoe, "Segoe UI", "DejaVu Sans", "Trebuchet MS", Verdana, "sans-serif"" align="justify">-->&iquest;Desea dejar de recibir notificaciones de <a href="https://www.RepoBox.com.mx">RepoBox</a>? De clic <a href="{LinkUnsubscribe}">AQUI</a>.<!-- SECCION CUATRO -->Visita nuestro sitio de Soporte <a href="https://repobox.freshdesk.com/support/home">Repositorio y Facturaci&oacute;n Electr&oacute;nica</a><a href="https://repobox.freshdesk.com/support/home"> </a>- <a href="https://htamexico.freshdesk.com/support/home"> ERP</a></p>';
  formatoStatico: any =
    '<p style="text-align: center;"><a href="http://www.repobox.com.mx"><img alt="Repobox" src="../assets/NuevoIndex/img/logos/logo.png" /></a></p> <p style="text-align: center;"><a href="{LinkImpresion}">Haz click aqu&iacute; para imprimir tu comprobante</a>&nbsp;Fecha de Recepci&oacute;n: <strong>{FECHA}</strong>A continuaci&oacute;n el resultado de la validaci&oacute;n de su comprobante fiscal:Folio de Validaci&oacute;n: <strong>{FOLIOVALIDACION}</strong>Folio de Env&iacute;o: <strong>{FOLIOENVIO}</strong>Emisor:<strong>{EMISOR}</strong>RFC:{RFCEMISOR}Receptor:<strong>{RECEPTOR}</strong>RFC:{RFCRECEPTOR}Folio:{FOLIOFAC}Fecha:{FECHAFAC}Serie:{SERIEFAC}UUID:{UUID}Resultado de Validaci&oacute;n:<img src="{IMGSTATUS}" /> {ERRORES}{TablaErrores}</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;"><img alt="Repobox Footer" src="http://www.repobox.com.mx/img/img_new/footer_repobox.png" style="float:left; height:160px; width:1000px" /><!-- SECCION TRES --></p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;"><!-- SECCION TRES PUNTO CINCO--><!--<td style="padding: 0 20px 40px 20px ;font-size: 14px; font-family: Segoe, "Segoe UI", "DejaVu Sans", "Trebuchet MS", Verdana, "sans-serif"" align="justify">-->&iquest;Desea dejar de recibir notificaciones de <a href="https://www.RepoBox.com.mx">RepoBox</a>? De clic <a href="{LinkUnsubscribe}">AQUI</a>.<!-- SECCION CUATRO -->Visita nuestro sitio de Soporte <a href="https://repobox.freshdesk.com/support/home">Repositorio y Facturaci&oacute;n Electr&oacute;nica</a><a href="https://repobox.freshdesk.com/support/home"> </a>- <a href="https://htamexico.freshdesk.com/support/home"> ERP</a></p>';

  botonImagenIndex1: boolean = false;
  botonImagenIndex2: boolean = false;
  botonImagenIndex3: boolean = false;
  botonImagenIndex4: boolean = false;
  botonImagenIndex5: boolean = false;
  botonImagenIndex6: boolean = false;
  botonImagenIndex7: boolean = false;
  botonImagenIndex8: boolean = false;

  ckeditorContent: string = this.formato;
  alerta = new SweetAlertModals();
  Image: any[] = [];
  @ViewChild(CKEditorComponent)
  ckEditor: CKEditorComponent;
  permisosUsuarios:ValidarPermisos;
  constructor(private _consultasService: ConsultasService,public router:Router) {

    this.permisosUsuarios = new ValidarPermisos();

    let usuarioEmpresa=JSON.parse(localStorage.getItem("usuario"));
    this.permisosUsuarios.consultarPermisos(usuarioEmpresa.Servicios);
  }
  ngAfterViewChecked() {
    (function($) {
      var options = {
        allowedFormats: ["jpg", "png", "gif"]
      };

      $.fn.imgUpload = function(opts) {
        if (this.filter("div").hasClass("img-upload")) {
          options = $.extend(options, opts);
          bindEvents(this);
        }
        return this;
      };

      function getHtmlErrorMsg(msg) {
        return (
          "<div class='alert alert-danger alert-dismissible'><button type='button' class='close' data-dismiss='alert'><span>&times;</span></button>" +
          msg +
          "</div>"
        );
      }

      function getHtmlImg(src) {
        return (
          "<img src='" +
          src +
          "' alt='Image preview' width='100' class='img-thumbnail'>"
        );
      }

      function isValidImgUrl(url, callback) {
        var img = new Image();
        img.onerror = function() {
          callback(url, false, "URL does not refer to an image.");
        };
        img.onload = function() {
          var fileExt = url.substring(url.length - 3).toLowerCase();
          if ($.inArray(fileExt, options.allowedFormats) > -1) {
            callback(url, true, "");
          } else {
            callback(url, false, "Image format not allowed.");
          }
        };
        img.src = url;
      }

      function bindEvents($imgUpload) {
        $imgUpload.find(".img-file-btn a").click(function() {
          showFileTab($(this).parent());
        });
        var $fileTab = $imgUpload.find(".img-file-tab");
        $fileTab.find(".img-select-btn").change(function() {
          selectImgFile($(this));
        });
        $fileTab.find(".img-remove-btn").click(function() {
          removeImgFile($(this));
        });
        $imgUpload.find(".img-url-btn a").click(function() {
          showUrlTab($(this).parent());
        });
        $imgUpload.find(".img-url-tab .img-select-btn").click(function() {
          selectImgUrl($(this));
        });
      }

      function showFileTab($fileBtn) {
        if (!$fileBtn.hasClass("active")) {
          var $imgUpload = $fileBtn.closest(".img-upload");
          var $urlTab = $imgUpload.find(".img-url-tab");

          $fileBtn.addClass("active");
          $imgUpload.find(".img-file-tab").show();
          $imgUpload.find(".img-url-btn").removeClass("active");
          $urlTab.hide();

          $urlTab.find(".alert").remove();
          $urlTab.find("input").val("");
          $urlTab.find(".img-select-btn").text("Submit");
          $urlTab.find("img").remove();
        }
      }

      function selectImgFile($selectBtn) {
        var $input = $selectBtn.find("input");
        var $fileTab = $selectBtn.closest(".img-file-tab");
        var hasFile = $input[0].files && $input[0].files[0];
        $fileTab.find(".alert").remove();

        if (!hasFile) {
          $fileTab.prepend(getHtmlErrorMsg("Error uploading file."));
          return;
        }

        var file = $input[0].files[0];
        var fileExt = file.name.substring(file.name.length - 3).toLowerCase();

        if ($.inArray(fileExt, options.allowedFormats) > -1) {
          var reader = new FileReader();
          reader.onload = function(e) {
            $fileTab.find("img").remove();
            $fileTab.append(getHtmlImg(reader.result));
          };
          reader.onerror = function(e) {
            $fileTab.prepend(getHtmlErrorMsg("Error uploading file."));
          };
          reader.readAsDataURL(file);

          $selectBtn.find("span").text("Cambiar");
          $fileTab.find(".img-remove-btn").css("display", "inline-block");
        } else {
          $fileTab.prepend(getHtmlErrorMsg("Image format not allowed."));
        }
      }

      function removeImgFile($removeBtn) {
        var $fileTab = $removeBtn.closest(".img-file-tab");
        $fileTab.find(".alert").remove();
        $fileTab.find(".img-select-btn span").text("Buscar");
        $fileTab.find("input").val("");
        $fileTab.find("img").remove();
        $removeBtn.hide();
      }

      function showUrlTab($urlBtn) {
        if (!$urlBtn.hasClass("active")) {
          var $imgUpload = $urlBtn.closest(".img-upload");
          var $fileTab = $imgUpload.find(".img-file-tab");

          $urlBtn.addClass("active");
          $imgUpload.find(".img-url-tab").show();
          $imgUpload.find(".img-file-btn").removeClass("active");
          $fileTab.hide();

          $fileTab.find(".alert").remove();
          $fileTab.find("input").val("");
          $fileTab.find(".img-select-btn span").text("Buscar");
          $fileTab.find(".img-remove-btn").hide();
          $fileTab.find("img").remove();
        }
      }

      function selectImgUrl($selectBtn) {
        var $urlTab = $selectBtn.closest(".img-url-tab");
        var $input = $urlTab.find("input");
        $urlTab.find(".alert").remove();

        if ($selectBtn.text() == "X") {
          $input.val("");
          $selectBtn.text("Submit");
          $urlTab.find("img").remove();
          return;
        }

        isValidImgUrl($urlTab.find("input:text").val(), function(
          url,
          isValid,
          msg
        ) {
          if (isValid) {
            $urlTab.find("input:hidden").val(url);
            $urlTab.find("img").remove();
            $urlTab.append(getHtmlImg(url));
            $selectBtn.text("X");
          } else {
            $urlTab.prepend(getHtmlErrorMsg(msg));
          }
        });
      }
    })(jQuery);
    // $("#cke_1_contents").css("height", "500px");
    $(".img-upload").imgUpload();
    //   $('#cke_1_contents').css({
    //     'height': '630px',

    //     //... and so on
    // });
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    let editor = this.ckEditor.instance;
    let config = editor.config;

    editor.config.height = "400";

    editor.config.toolbarGroups = [
      { name: "document", groups: ["mode", "document", "doctools"] },
      { name: "clipboard", groups: ["clipboard", "undo"] },
      {
        name: "editing",
        groups: ["find", "selection", "spellchecker", "editing"]
      },
      { name: "forms", groups: ["forms"] },
      "/",
      { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
      {
        name: "paragraph",
        groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"]
      },
      { name: "links", groups: ["links"] },
      { name: "insert", groups: ["insert"] },
      "/",
      { name: "styles", groups: ["styles"] },
      { name: "colors", groups: ["colors"] },
      { name: "tools", groups: ["tools"] },
      { name: "others", groups: ["others"] },
      { name: "about", groups: ["about"] }
    ];

    editor.ui.addRichCombo("my-combo", {
      label: "Parámetros",
      title: "Parámetros",
      toolbar: "basicstyles,0",

      panel: {
        multiSelect: false,
        attributes: {}
      },

      init: function() {
        var cont = 0;
        var removeItem = "";
        var objCods_ = null;

        objCods_ = [
          "{FECHA}",
          "{FOLIOVALIDACION}",
          "{FOLIOENVIO}",
          "{EMISOR}",
          "{RFCEMISOR}",
          "{RECEPTOR}",
          "{RFCRECEPTOR}",
          "{FOLIOFAC}",
          "{FECHAFAC}",
          "{SERIEFAC}",
          "{UUID}",
          "{ERRORES}",
          "{TablaErrores}"
        ];

        while (objCods_.length != 0) {
          removeItem = objCods_[0];
          this.add(removeItem, removeItem);
          objCods_.splice($.inArray(objCods_[0], objCods_), 1);
          cont++;
        }
      },
      onClick: function(value) {
        editor.focus();
        editor.fire("saveSnapshot");

        editor.insertHtml(value);

        editor.fire("saveSnapshot");
      }
    });
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if(this.permisosUsuarios.PersonalizarNotValidacion!=true)
    {
      this.router.navigate(["/comprobante/configuracion"])
    }

  }

  public Guardar() {

    //this.formato.replace("{{'}}",'{{"}}')


    if (!this.ckeditorContent.includes("{FECHA}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {FECHA}");
    } else if (!this.ckeditorContent.includes("{FOLIOVALIDACION}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {FOLIOVALIDACION}");
    } else if (!this.ckeditorContent.includes("{FOLIOENVIO}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {FOLIOENVIO}");
    } else if (!this.ckeditorContent.includes("{EMISOR}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {EMISOR}");
    } else if (!this.ckeditorContent.includes("{RFCEMISOR}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {RFCEMISOR}");
    } else if (!this.ckeditorContent.includes("{RECEPTOR}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {RECEPTOR}");
    } else if (!this.ckeditorContent.includes("{RFCRECEPTOR}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {RFCRECEPTOR}");
    } else if (!this.ckeditorContent.includes("{FOLIOFAC}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {FOLIOFAC}");
    } else if (!this.ckeditorContent.includes("{FECHAFAC}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {FECHAFAC}");
    } else if (!this.ckeditorContent.includes("{SERIEFAC}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {SERIEFAC}");
    } else if (!this.ckeditorContent.includes("{UUID}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {UUID}");
    } else if (!this.ckeditorContent.includes("{ERRORES}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {ERRORES}");
    } else if (!this.ckeditorContent.includes("{TablaErrores}")) {
      this.alerta.ModalError("Error", "Agrege el parametro {TablaErrores}");
    } else {
      //console.log(atob("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"))
      this._consultasService
        .EditarAcuseValidacion(btoa(this.ckeditorContent))
        .subscribe(data => {

          if (data.success == true)
            this.alerta.ModalSuccess("Perfecto", "Guardado con exito");
          else this.alerta.ModalError("Error", data.msg.toString());
        });
    }
  }

  public CalcelarFormato() {
    this.ckeditorContent = this.formatoStatico;
  }
  image: any;
  // ImagenLista(e)
  // {
  // console.log(e);

  // this.image= e.target.res

  // // var imagen = e.target.files[0].name;

  // // this.image.push(imagen);
  // console.log(this.image)

  // }

  // resultt:any;
  // sumarIndex()
  // {
  //   this.botonImagenIndex++;
  //   this.resultt='"<div  class="container row"><form> <div class="form-group"><div class="panel panel-default img-upload"><div class="panel-body img-file-tab"><div><span class="btn btn-default btn-file img-select-btn" (change)="sumarIndex()"><span class="form-control">Buscar</span><input type="file" name="img-file-input"></span><span class="btn btn-default img-remove-btn" style="color: red">X</span></div></div></div></div></form>"';
  // }
  // @ViewChild('clone') this.resultt;

  // // Where to insert the cloned content
  // @ViewChild('container', {read:ViewContainerRef}) container;

  sumarIndex(sc) {

    if (sc == 1) {
      this.botonImagenIndex1 = true;
    }
    if (sc == 2) {
      this.botonImagenIndex2 = true;
    }
    if (sc == 3) {
      this.botonImagenIndex3 = true;
    }
    if (sc == 4) {
      this.botonImagenIndex4 = true;
    }
    if (sc == 5) {
      this.botonImagenIndex5 = true;
    }
    if (sc == 6) {
      this.botonImagenIndex6 = true;
    }
    if (sc == 7) {
      this.botonImagenIndex7 = true;
    }
    if (sc == 8) {
      this.botonImagenIndex8 = true;
    }

    //  var itm = document.getElementById("myList2").lastChild;
    //  var cln = itm.cloneNode(true);
    // document.getElementById("myList1").appendChild(cln);
  }
  removerItem(sc) {

    if (sc == 1) {
      this.botonImagenIndex1 = false;
    }
    if (sc == 2) {
      this.botonImagenIndex2 = false;
    }
    if (sc == 3) {
      this.botonImagenIndex3 = false;
    }
    if (sc == 4) {
      this.botonImagenIndex4 = false;
    }
    if (sc == 5) {
      this.botonImagenIndex5 = false;
    }
    if (sc == 6) {
      this.botonImagenIndex6 = false;
    }
    if (sc == 7) {
      this.botonImagenIndex7 = false;
    }
    if (sc == 8) {
      this.botonImagenIndex8 = false;
    }
    // var elem = document.getElementById(idName);
    // elem.parentNode.removeChild(elem);
  }
}
